
import React, { useEffect, useRef } from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from "react-redux";
import { setNumberOfSessions } from "../../../redux/reducers/createOrderSlice";

export default function DropDownForSessions(props) {
  const dispatch = useDispatch()
  const { numberOfsessions } = useSelector((state) => state.createOrderSlice)
  const { recurrenceRule } = useSelector((state) => state.createOrderSlice);
  console.log("no of session", numberOfsessions)
  // function DropdownInput(props) {
  const { label, options, onChange, disableCondition,error } = props;

  // const prevDaysRef = useRef(recurrenceRule.days);

  // useEffect(() => {
  //   if (JSON.stringify(prevDaysRef.current) !== JSON.stringify(recurrenceRule.days)) {
  //     prevDaysRef.current = recurrenceRule.days; 
  //     dispatch(setNumberOfSessions({ numberOfsessions: 0 }));
  //   }
  // }, [recurrenceRule.days]);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          onChange={(e) => onChange(e.target.value)}
          disabled={disableCondition}
          value={numberOfsessions}
        >
          {options.map((item) => {
            return (
              <MenuItem value={item}>{item}</MenuItem>
            )

          })}

        </Select>
        {error ? !numberOfsessions && <p className='form-error-message'>This field is required</p> :null}

      </FormControl>
    </Box>
  );


}


